import { useCallback, useState } from 'react'
import { downloadListingFunnelExport } from 'api/admin/listing/downloadListingFunnelExport'
import { parseErrorMessage } from 'api'

export const useListingFunnelExport = (listingId: number) => {
  const [exportingEventType, setExportingEventType] = useState<string | null>(
    null
  )
  const [exportError, setExportError] = useState<string | null>(null)

  const exportStep = useCallback(
    async (
      eventType: string,
      timeRange: { startDate: string; endDate: string }
    ) => {
      setExportingEventType(eventType)
      setExportError(null)
      try {
        await downloadListingFunnelExport(listingId, eventType, timeRange)
      } catch (error) {
        setExportError(parseErrorMessage(error) ?? 'Export failed')
      } finally {
        setExportingEventType(null)
      }
    },
    [listingId]
  )

  return { exportStep, exportingEventType, exportError }
}
